import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/blur-images"
    exact
    path="/consumer/features/blur-images"
    component={AsyncPage}
  />,
];
